import { render, staticRenderFns } from "./VerificationPendingAlert.vue?vue&type=template&id=3fb320c5&"
import script from "./VerificationPendingAlert.vue?vue&type=script&lang=js&"
export * from "./VerificationPendingAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports